import { render, staticRenderFns } from "./PriceSet.vue?vue&type=template&id=c2cc48a8&scoped=true&"
import script from "./PriceSet.vue?vue&type=script&lang=js&"
export * from "./PriceSet.vue?vue&type=script&lang=js&"
import style0 from "./PriceSet.vue?vue&type=style&index=0&id=c2cc48a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc48a8",
  null
  
)

export default component.exports